import { forwardRef, useId, type InputHTMLAttributes } from 'react';
import './MobInput.css';

interface MobInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  hint?: string;
}

export const MobInput = forwardRef<HTMLInputElement, MobInputProps>(
  function MobInput(
    { label, error, hint, id, className, ...rest },
    ref,
  ) {
    const generatedId = useId();
    const inputId = id ?? `mob-in-${generatedId}`;
    const describedBy = error
      ? `${inputId}-err`
      : hint
        ? `${inputId}-hint`
        : undefined;

    return (
      <div
        className={`mob-input${error ? ' has-error' : ''}${className ? ` ${className}` : ''}`}
      >
        <label className="mob-input__label" htmlFor={inputId}>
          {label}
        </label>
        <input
          ref={ref}
          id={inputId}
          className="mob-input__field"
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy}
          {...rest}
        />
        {error ? (
          <div id={`${inputId}-err`} className="mob-input__err" role="alert">
            {error}
          </div>
        ) : hint ? (
          <div id={`${inputId}-hint`} className="mob-input__hint">
            {hint}
          </div>
        ) : null}
      </div>
    );
  },
);
